import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Container, Form, Card, Row, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import NotyfContext from '../../contexts/NotyfContext';
import { useDispatch, useSelector } from 'react-redux';
import { blankCheckout, saveCheckout } from '../../redux/slices/CheckoutSlice';
import { fetchCurrentPlan, updateCurrentPlan, fetchPackagesDetail } from '../../redux/slices/EnhanceDisputeSlice';
import { Check } from 'react-feather';
import Logo from './disputely-logo-blue.svg';
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask';
import moment from 'moment';
import { callUserActvity, createDisputeLatter } from '../../redux/slices/CommonSlice';
import OnboardingSteps from '../../components/new/OnboardingSteps';
import Loader from '../../components/Loader';

const CheckoutComponent = ({ showOptions, plan, mailing }) => {
  const notyf = useContext(NotyfContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [spinner, setSpinner] = useState(false);

  const checkoutSave = useSelector(state => state.checkout.checkoutResponse);
  const currentPlan = useSelector(state => state.enhanceDispute.currentPlan);
  const mailingOption = useSelector(state => state.enhanceDispute.mailingOption);
  const packages = useSelector(state => state.enhanceDispute.packages);
  const packagesDetail = useSelector(state => state.enhanceDispute.packagesDetail);

  const currentPlanStatus = useSelector(state => state.enhanceDispute.currentPlanStatus);

  React.useEffect(() => {
    dispatch(fetchCurrentPlan());
    dispatch(fetchPackagesDetail());
  }, []);

  useEffect(() => {
    if (checkoutSave && Object.keys(checkoutSave).length > 0) {
      if (checkoutSave.error == 0) {
        notyf.open({
          type: 'success',
          message: 'Congratulations! Checkout successful.',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        dispatch(blankCheckout());
        dispatch(
          updateCurrentPlan({
            planId: plan,
            mailingOption: mailing,
          })
        );
        
        // dispatch(createDisputeLatter());
        setTimeout(() => {
          setSpinner(false);
          navigate(`/payment-confirmation/${plan === 1 ? 'standard' : 'enhanced'}`);
        }, 3000);
      } else {
        setSpinner(false);
        notyf.open({
          type: 'danger',
          message: checkoutSave.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [checkoutSave]);
  useEffect(() => {
    return () => {
      dispatch(blankCheckout());
    };
  }, []);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: '',
      last_name: '',
      credit_card_number: '',
      expiry: '',
      cvv: '',
      address: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      order: 'disputely',
    },
    validationSchema: Yup.object().shape({
      first_name: Yup.string().max(255).required('First Name is required'),
      last_name: Yup.string().max(255).required('Last Name is required'),
      credit_card_number: Yup.number().required('Credit Card Number is required'),
      expiry: Yup.string().max(255).required('Expiry  is required'),
      cvv: Yup.number().required('CVV  is required'),
      city: Yup.string().max(255).required('City is required'),
      state: Yup.string().max(255).required('State is required'),
      zip: Yup.string().max(255).required('Zip is required'),
      order: Yup.string().required().oneOf(['disputely', 'diy'], 'Order is required'),
      address: Yup.string().max(255).required('Address is required'),
    }),
    onSubmit: async values => {
      if (values.expiry.slice(0, 2) > 12) {
        formik.setFieldError('expiry', 'Set Valid expiry date');
        return;
      }
      if (values.expiry.slice(2) < moment().format('YY')) {
        formik.setFieldError('expiry', 'Set Valid expiry date');
        return;
      }
      let expiryDate = values.expiry.slice(0, 2) + '/' + values.expiry.slice(2);
      // navigate('/dashboard');
      let obj = {
        first_name: values.first_name,
        last_name: values.last_name,
        number: values.credit_card_number,
        expiry: expiryDate,
        cvv: values.cvv,
        address: values.address,
        address2: values.address2,
        city: values.city,
        state: values.state,
        zip: values.zip,
        planId: plan,
      };
      setSpinner(true);
      dispatch(callUserActvity('Call Checkout Event'));
      dispatch(saveCheckout(obj));
      
    },
  });
  const maskGenerator = createDefaultMaskGenerator('9999 9999 9999 9999');
  const maskGeneratorExpiry = createDefaultMaskGenerator('99/99');
  const maskGeneratorCVV = createDefaultMaskGenerator('9999');

  if (currentPlanStatus == 'idle' || spinner) return <Loader />;

  return (
    <React.Fragment>
      <Helmet title='Checkout' />
      <style>
        {`
        @media (max-width: 1284px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 980px !important;
                }
              }

              @media (max-width: 992px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 980px !important;
                }
              }

              @media (max-width: 768px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 980px !important;
                }
              }
        `}
      </style>
      <Container fluid className='container-fluid-1335 p-0 mb-5'>
        {showOptions && <OnboardingSteps activeStepButtonLeft='-2px' progressComplete='1140px' activeStep={6} />}
        <Row className='pt-5'>
          <Col xs='12' style={{ margin: 'auto' }}>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col xs={12} md={6}>
                  <h3>Payment Information</h3>
                  <Row className='mt-1 mb-5'>
                    <Col xs='6' className='mt-3'>
                      <Form.Label className='text-light-gray form-label' htmlFor='cardholder_name'>
                        First Name
                      </Form.Label>
                      <Form.Control type='text' id='first_name' name='first_name' placeholder='First Name' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.first_name} isInvalid={Boolean(formik.touched.first_name && formik.errors.first_name)} />
                      {!!formik.touched.first_name && <Form.Control.Feedback type='invalid'>{formik.errors.first_name}</Form.Control.Feedback>}
                    </Col>
                    <Col xs='6' className='mt-3'>
                      <Form.Label className='text-light-gray form-label' htmlFor='cardholder_name'>
                        Last Name
                      </Form.Label>
                      <Form.Control type='text' id='last_name' name='last_name' placeholder='Last Name' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.last_name} isInvalid={Boolean(formik.touched.last_name && formik.errors.last_name)} />
                      {!!formik.touched.last_name && <Form.Control.Feedback type='invalid'>{formik.errors.last_name}</Form.Control.Feedback>}
                    </Col>
                    <Col xs='6' className='mt-3'>
                      <Form.Label className='text-light-gray form-label' htmlFor='credit_card_number'>
                        Credit Card Number
                      </Form.Label>
                      <MaskedInput
                        maskGenerator={maskGenerator}
                        type='text'
                        id='credit_card_number'
                        name='credit_card_number'
                        className={`form-control form-control-lg ${Boolean(formik.touched.credit_card_number && formik.errors.credit_card_number) ? 'is-invalid' : ''}`}
                        placeholder='XXXX XXXXX XXXX XXXX'
                        size='lg'
                        onChange={e => {
                          formik.setFieldValue('credit_card_number', e);
                        }}
                        value={formik.values.credit_card_number}
                        isInvalid={Boolean(formik.touched.credit_card_number && formik.errors.credit_card_number)}
                      />
                      {!!formik.touched.credit_card_number && <Form.Control.Feedback type='invalid'>{formik.errors.credit_card_number}</Form.Control.Feedback>}
                    </Col>
                    <Col xs='3' className='mt-3'>
                      <Form.Label className='text-light-gray form-label' htmlFor='expiry'>
                        Expiration
                      </Form.Label>
                      <MaskedInput
                        maskGenerator={maskGeneratorExpiry}
                        type='text'
                        id='expiry'
                        name='expiry'
                        className={`form-control form-control-lg ${Boolean(formik.touched.expiry && formik.errors.expiry) ? 'is-invalid' : ''}`}
                        placeholder='MM/YY'
                        size='lg'
                        onChange={e => {
                          formik.setFieldValue('expiry', e);
                        }}
                        value={formik.values.expiry}
                        isInvalid={Boolean(formik.touched.expiry && formik.errors.expiry)}
                      />
                      {!!formik.touched.expiry && <Form.Control.Feedback type='invalid'>{formik.errors.expiry}</Form.Control.Feedback>}
                    </Col>
                    <Col xs='3' className='mt-3'>
                      <Form.Label className='text-light-gray form-label' htmlFor='cvv'>
                        CVV
                      </Form.Label>
                      <MaskedInput
                        maskGenerator={maskGeneratorCVV}
                        type='password'
                        id='cvv'
                        name='cvv'
                        className={`form-control form-control-lg ${Boolean(formik.touched.cvv && formik.errors.cvv) ? 'is-invalid' : ''}`}
                        placeholder='***'
                        size='lg'
                        onChange={e => {
                          formik.setFieldValue('cvv', e);
                        }}
                        value={formik.values.cvv}
                        isInvalid={Boolean(formik.touched.cvv && formik.errors.cvv)}
                      />
                      {!!formik.touched.cvv && <Form.Control.Feedback type='invalid'>{formik.errors.cvv}</Form.Control.Feedback>}
                    </Col>
                  </Row>
                  <h3 className='mb-0'>Billing Address</h3>

                  <Row className='mt-0'>
                    <Col xs='12' className='mt-3'>
                      <Form.Label className='text-light-gray form-label'>Address</Form.Label>
                      <Form.Control type='text' name='address' id='address' placeholder='Address' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.address} isInvalid={Boolean(formik.touched.address && formik.errors.address)} />
                      {!!formik.touched.address && <Form.Control.Feedback type='invalid'>{formik.errors.address}</Form.Control.Feedback>}
                    </Col>
                    <Col xs='12' className='mt-3'>
                      <Form.Label className='text-light-gray form-label'>Address (Optional)</Form.Label>
                      <Form.Control type='text' name='address2' id='address2' placeholder='Address (Optional)' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.address2} />
                    </Col>
                    <Col xs='5' className='mt-3'>
                      <Form.Label className='text-light-gray form-label'>City</Form.Label>
                      <Form.Control type='text' name='city' id='city' placeholder='City' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.city} isInvalid={Boolean(formik.touched.city && formik.errors.city)} />
                      {!!formik.touched.city && <Form.Control.Feedback type='invalid'>{formik.errors.city}</Form.Control.Feedback>}
                    </Col>
                    <Col xs='4' className='mt-3'>
                      <Form.Label className='text-light-gray form-label'>State</Form.Label>
                      <Form.Select className='form-control' name='state' id='state' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.state} isInvalid={Boolean(formik.touched.state && formik.errors.state)}>
                        <option value=''>Select a state</option>
                        <option value='Alabama'>AL</option>
                        <option value='Alaska'>AK</option>
                        <option value='Arizona'>AZ</option>
                        <option value='Arkansas'>AR</option>
                        <option value='California'>CA</option>
                        <option value='Colorado'>CO</option>
                        <option value='Connecticut'>CT</option>
                        <option value='Delaware'>DE</option>
                        <option value='Florida'>FL</option>
                        <option value='Georgia'>GA</option>
                        <option value='Hawaii'>HI</option>
                        <option value='Idaho'>ID</option>
                        <option value='Illinois'>IL</option>
                        <option value='Indiana'>IN</option>
                        <option value='Iowa'>IA</option>
                        <option value='Kansas'>KS</option>
                        <option value='Kentucky'>KY</option>
                        <option value='Louisiana'>LA</option>
                        <option value='Maine'>ME</option>
                        <option value='Maryland'>MD</option>
                        <option value='Massachusetts'>MA</option>
                        <option value='Michigan'>MI</option>
                        <option value='Minnesota'>MN</option>
                        <option value='Mississippi'>MS</option>
                        <option value='Missouri'>MO</option>
                        <option value='Montana'>MT</option>
                        <option value='Nebraska'>NE</option>
                        <option value='Nevada'>NV</option>
                        <option value='New Hampshire'>NH</option>
                        <option value='New Jersey'>NJ</option>
                        <option value='New Mexico'>NM</option>
                        <option value='New York'>NY</option>
                        <option value='North Carolina'>NC</option>
                        <option value='North Dakota'>ND</option>
                        <option value='Ohio'>OH</option>
                        <option value='Oklahoma'>OK</option>
                        <option value='Oregon'>OR</option>
                        <option value='Pennsylvania'>PA</option>
                        <option value='Rhode Island'>RI</option>
                        <option value='South Carolina'>SC</option>
                        <option value='South Dakota'>SD</option>
                        <option value='Tennessee'>TN</option>
                        <option value='Texas'>TX</option>
                        <option value='Utah'>UT</option>
                        <option value='Vermont'>VT</option>
                        <option value='Virginia'>VA</option>
                        <option value='Washington'>WA</option>
                        <option value='West Virginia'>WV</option>
                        <option value='Wisconsin'>WI</option>
                        <option value='Wyoming'>WY</option>
                      </Form.Select>
                      {!!formik.touched.state && <Form.Control.Feedback type='invalid'>{formik.errors.state}</Form.Control.Feedback>}
                    </Col>
                    <Col xs='3' className='mt-3'>
                      <Form.Label className='text-light-gray form-label'>Zip</Form.Label>
                      <Form.Control type='text' name='zip' id='zip' placeholder='Zip' size='lg' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.zip} isInvalid={Boolean(formik.touched.zip && formik.errors.zip)} />
                      {!!formik.touched.zip && <Form.Control.Feedback type='invalid'>{formik.errors.zip}</Form.Control.Feedback>}
                    </Col>
                  </Row>

                  {/* <Row className='mt-3 mb-3'>
                    <Col xs='12'>
                      <Form.Check type='radio' name='order' id='disputely' label='Disputely ($5)' style={{ fontSize: '20px' }} value='disputely' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.order && formik.errors.order)} defaultChecked={formik.values.order === 'disputely'} />
                    </Col>
                    <Col xs='12'>
                      <Form.Check type='radio' name='order' id='diy' label='DIY ($0)' style={{ fontSize: '20px' }} value='diy' onChange={formik.handleChange} onBlur={formik.handleBlur} isInvalid={Boolean(formik.touched.order && formik.errors.order)} defaultChecked={formik.values.order === 'diy'} />
                    </Col>
                  </Row> */}
                  <Row>
                    <Form.Group className='mb-5 mt-3' controlId='formBasicCheckbox'>
                      <Form.Check className='text-dark-blue' type='checkbox' label='Remember my payment information for next payments' />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Col lg='12' className='d-flex flex-row justfity-content-between'>
                      {showOptions && (
                        <Button variant={`outline-primary`} onClick={() => navigate('/enhanced-dispute-onboarding')} type='button' size='lg' className='w-25'>
                          Back
                        </Button>
                      )}
                      <Button variant='primary ms-auto' disabled={formik.isSubmitting || spinner} type='submit' size='lg' className='w-50'>
                        Checkout {spinner && <Spinner as='span' animation='border' size='lg' role='status' aria-hidden='true' />}
                      </Button>
                    </Col>
                  </Row>
                </Col>
                <Col lg={4} className='mb-5 mb-md-3 flex-lg-fill offset-0 offset-md-2 order-first order-md-last'>
                  <Card className='rounded-4 border-2 px-4 py-4 mb-0' style={{ borderColor: '#000' }}>
                    <div className='d-flex flex-row justify-content-between align-items-start'>
                      <div className='item-group pb-3'>
                        <img src={Logo} alt='disputely logo' className='text-primary m-auto' width='110' />

                        <div className='text-regular-14 text-black'>
                          <div className='d-flex flex-row justify-content-between align-items-center'>
                            {plan === 1 ? <p className='fw-semibold w-75 fs-6 text-black'>Expedited Processing & Mailing w/ Dispute.ly </p> : <p className='fw-semibold w-75 fs-6 text-black'>Enhanced Disputes + Expedited Processing & Mailing w/ Dispute.ly </p>}
                            <div class='d-flex justify-content-between flex-row fw-bold fs-6' style={{ alignSelf: 'baseline' }}>
                              <div className='me-3'>$</div>
                              <div> {packages[plan]}</div>
                            </div>
                          </div>

                          <p className='mb-0' style={{ fontWeight: '400' }}>
                            {packagesDetail.length > 0 && packagesDetail[plan - 1]?.total_negative} Negative items
                          </p>
                          <p className='mb-0' style={{ fontWeight: '400' }}>
                            {packagesDetail.length > 0 && packagesDetail[plan - 1]?.total_destination} Destinations
                          </p>
                          <p className='mb-0' style={{ fontWeight: '400' }}>
                            {packagesDetail.length > 0 && packagesDetail[plan - 1]?.total_letter} Total letters
                          </p>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default CheckoutComponent;
